import React from 'react';
import { Box } from '@mui/material';
import { BRAND } from '../theme';

// Fireworks — lightweight CSS-only celebration on mint_confirmed.
// 12 colored particles burst outward from the centre. No external libs.
//
// Props:
//   show     boolean — render when true
//   onDone   called once the animation completes (~1.6s)

const COLORS = [BRAND.violet, BRAND.violetLight, BRAND.cyan, BRAND.cyanLight, BRAND.success];

export default function Fireworks({ show = false, onDone }) {
  React.useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => onDone?.(), 1600);
    return () => clearTimeout(t);
  }, [show, onDone]);

  if (!show) return null;

  const particles = Array.from({ length: 16 }, (_, i) => i);

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 2000,
        display: 'grid',
        placeItems: 'center',
      }}
      data-testid="fireworks"
    >
      <Box sx={{ position: 'relative', width: 0, height: 0 }}>
        {particles.map((i) => {
          const angle = (i / particles.length) * Math.PI * 2;
          const tx = Math.cos(angle) * 220;
          const ty = Math.sin(angle) * 220;
          const color = COLORS[i % COLORS.length];
          return (
            <Box
              key={i}
              sx={{
                position: 'absolute',
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: color,
                boxShadow: `0 0 12px ${color}`,
                top: 0,
                left: 0,
                transform: 'translate(-50%, -50%)',
                animation: `firework-${i} 1.6s ease-out forwards`,
                [`@keyframes firework-${i}`]: {
                  '0%':   { transform: 'translate(-50%, -50%) scale(0.4)', opacity: 1 },
                  '70%':  { opacity: 1 },
                  '100%': {
                    transform: `translate(calc(-50% + ${tx}px), calc(-50% + ${ty}px)) scale(0.6)`,
                    opacity: 0,
                  },
                },
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
}
